import { logEvent } from './logEvent';

export function useLogEvent() {
  return logEvent;
}
